import _defineProperty from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.array.reduce.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { ResourceMap } from '../../../base/common/map.js';
import * as arrays from '../../../base/common/arrays.js';
import * as types from '../../../base/common/types.js';
import * as objects from '../../../base/common/objects.js';
import { URI } from '../../../base/common/uri.js';
import { OVERRIDE_PROPERTY_PATTERN, overrideIdentifierFromKey } from './configurationRegistry.js';
import { addToValueTree, toValuesTree, getConfigurationValue, getDefaultValues, getConfigurationKeys, removeFromValueTree } from './configuration.js';
export var ConfigurationModel = /*#__PURE__*/function () {
  function ConfigurationModel() {
    var _contents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var _overrides = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    _classCallCheck(this, ConfigurationModel);

    this._contents = _contents;
    this._keys = _keys;
    this._overrides = _overrides;
    this.isFrozen = false;
  }

  _createClass(ConfigurationModel, [{
    key: "contents",
    get: function get() {
      return this.checkAndFreeze(this._contents);
    }
  }, {
    key: "overrides",
    get: function get() {
      return this.checkAndFreeze(this._overrides);
    }
  }, {
    key: "keys",
    get: function get() {
      return this.checkAndFreeze(this._keys);
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this._keys.length === 0 && Object.keys(this._contents).length === 0 && this._overrides.length === 0;
    }
  }, {
    key: "getValue",
    value: function getValue(section) {
      return section ? getConfigurationValue(this.contents, section) : this.contents;
    }
  }, {
    key: "override",
    value: function override(identifier) {
      var overrideContents = this.getContentsForOverrideIdentifer(identifier);

      if (!overrideContents || typeof overrideContents !== 'object' || !Object.keys(overrideContents).length) {
        // If there are no valid overrides, return self
        return this;
      }

      var contents = {};

      var _iterator = _createForOfIteratorHelper(arrays.distinct([].concat(_toConsumableArray(Object.keys(this.contents)), _toConsumableArray(Object.keys(overrideContents))))),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;
          var contentsForKey = this.contents[key];
          var overrideContentsForKey = overrideContents[key]; // If there are override contents for the key, clone and merge otherwise use base contents

          if (overrideContentsForKey) {
            // Clone and merge only if base contents and override contents are of type object otherwise just override
            if (typeof contentsForKey === 'object' && typeof overrideContentsForKey === 'object') {
              contentsForKey = objects.deepClone(contentsForKey);
              this.mergeContents(contentsForKey, overrideContentsForKey);
            } else {
              contentsForKey = overrideContentsForKey;
            }
          }

          contents[key] = contentsForKey;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return new ConfigurationModel(contents, this.keys, this.overrides);
    }
  }, {
    key: "merge",
    value: function merge() {
      var _this = this;

      var contents = objects.deepClone(this.contents);
      var overrides = objects.deepClone(this.overrides);

      var keys = _toConsumableArray(this.keys);

      for (var _len = arguments.length, others = new Array(_len), _key = 0; _key < _len; _key++) {
        others[_key] = arguments[_key];
      }

      for (var _i = 0, _others = others; _i < _others.length; _i++) {
        var other = _others[_i];
        this.mergeContents(contents, other.contents);

        var _iterator2 = _createForOfIteratorHelper(other.overrides),
            _step2;

        try {
          var _loop = function _loop() {
            var otherOverride = _step2.value;

            var _overrides$filter = overrides.filter(function (o) {
              return arrays.equals(o.identifiers, otherOverride.identifiers);
            }),
                _overrides$filter2 = _slicedToArray(_overrides$filter, 1),
                override = _overrides$filter2[0];

            if (override) {
              _this.mergeContents(override.contents, otherOverride.contents);
            } else {
              overrides.push(objects.deepClone(otherOverride));
            }
          };

          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        var _iterator3 = _createForOfIteratorHelper(other.keys),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var key = _step3.value;

            if (keys.indexOf(key) === -1) {
              keys.push(key);
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }

      return new ConfigurationModel(contents, keys, overrides);
    }
  }, {
    key: "freeze",
    value: function freeze() {
      this.isFrozen = true;
      return this;
    }
  }, {
    key: "mergeContents",
    value: function mergeContents(source, target) {
      for (var _i2 = 0, _Object$keys = Object.keys(target); _i2 < _Object$keys.length; _i2++) {
        var key = _Object$keys[_i2];

        if (key in source) {
          if (types.isObject(source[key]) && types.isObject(target[key])) {
            this.mergeContents(source[key], target[key]);
            continue;
          }
        }

        source[key] = objects.deepClone(target[key]);
      }
    }
  }, {
    key: "checkAndFreeze",
    value: function checkAndFreeze(data) {
      if (this.isFrozen && !Object.isFrozen(data)) {
        return objects.deepFreeze(data);
      }

      return data;
    }
  }, {
    key: "getContentsForOverrideIdentifer",
    value: function getContentsForOverrideIdentifer(identifier) {
      var _iterator4 = _createForOfIteratorHelper(this.overrides),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var override = _step4.value;

          if (override.identifiers.indexOf(identifier) !== -1) {
            return override.contents;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return null;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        contents: this.contents,
        overrides: this.overrides,
        keys: this.keys
      };
    } // Update methods

  }, {
    key: "setValue",
    value: function setValue(key, value) {
      this.addKey(key);
      addToValueTree(this.contents, key, value, function (e) {
        throw new Error(e);
      });
    }
  }, {
    key: "removeValue",
    value: function removeValue(key) {
      if (this.removeKey(key)) {
        removeFromValueTree(this.contents, key);
      }
    }
  }, {
    key: "addKey",
    value: function addKey(key) {
      var index = this.keys.length;

      for (var i = 0; i < index; i++) {
        if (key.indexOf(this.keys[i]) === 0) {
          index = i;
        }
      }

      this.keys.splice(index, 1, key);
    }
  }, {
    key: "removeKey",
    value: function removeKey(key) {
      var index = this.keys.indexOf(key);

      if (index !== -1) {
        this.keys.splice(index, 1);
        return true;
      }

      return false;
    }
  }]);

  return ConfigurationModel;
}();
export var DefaultConfigurationModel = /*#__PURE__*/function (_ConfigurationModel) {
  _inherits(DefaultConfigurationModel, _ConfigurationModel);

  var _super = _createSuper(DefaultConfigurationModel);

  function DefaultConfigurationModel() {
    _classCallCheck(this, DefaultConfigurationModel);

    var contents = getDefaultValues();
    var keys = getConfigurationKeys();
    var overrides = [];

    for (var _i3 = 0, _Object$keys2 = Object.keys(contents); _i3 < _Object$keys2.length; _i3++) {
      var key = _Object$keys2[_i3];

      if (OVERRIDE_PROPERTY_PATTERN.test(key)) {
        overrides.push({
          identifiers: [overrideIdentifierFromKey(key).trim()],
          keys: Object.keys(contents[key]),
          contents: toValuesTree(contents[key], function (message) {
            return console.error("Conflict in default settings file: ".concat(message));
          })
        });
      }
    }

    return _super.call(this, contents, keys, overrides);
  }

  return DefaultConfigurationModel;
}(ConfigurationModel);
export var Configuration = /*#__PURE__*/function () {
  function Configuration(_defaultConfiguration, _localUserConfiguration) {
    var _remoteUserConfiguration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new ConfigurationModel();

    var _workspaceConfiguration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new ConfigurationModel();

    var _folderConfigurations = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : new ResourceMap();

    var _memoryConfiguration = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : new ConfigurationModel();

    var _memoryConfigurationByResource = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : new ResourceMap();

    var _freeze = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : true;

    _classCallCheck(this, Configuration);

    this._defaultConfiguration = _defaultConfiguration;
    this._localUserConfiguration = _localUserConfiguration;
    this._remoteUserConfiguration = _remoteUserConfiguration;
    this._workspaceConfiguration = _workspaceConfiguration;
    this._folderConfigurations = _folderConfigurations;
    this._memoryConfiguration = _memoryConfiguration;
    this._memoryConfigurationByResource = _memoryConfigurationByResource;
    this._freeze = _freeze;
    this._workspaceConsolidatedConfiguration = null;
    this._foldersConsolidatedConfigurations = new ResourceMap();
    this._userConfiguration = null;
  }

  _createClass(Configuration, [{
    key: "getValue",
    value: function getValue(section, overrides, workspace) {
      var consolidateConfigurationModel = this.getConsolidateConfigurationModel(overrides, workspace);
      return consolidateConfigurationModel.getValue(section);
    }
  }, {
    key: "updateValue",
    value: function updateValue(key, value) {
      var overrides = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var memoryConfiguration;

      if (overrides.resource) {
        memoryConfiguration = this._memoryConfigurationByResource.get(overrides.resource);

        if (!memoryConfiguration) {
          memoryConfiguration = new ConfigurationModel();

          this._memoryConfigurationByResource.set(overrides.resource, memoryConfiguration);
        }
      } else {
        memoryConfiguration = this._memoryConfiguration;
      }

      if (value === undefined) {
        memoryConfiguration.removeValue(key);
      } else {
        memoryConfiguration.setValue(key, value);
      }

      if (!overrides.resource) {
        this._workspaceConsolidatedConfiguration = null;
      }
    }
  }, {
    key: "userConfiguration",
    get: function get() {
      if (!this._userConfiguration) {
        this._userConfiguration = this._remoteUserConfiguration.isEmpty() ? this._localUserConfiguration : this._localUserConfiguration.merge(this._remoteUserConfiguration);

        if (this._freeze) {
          this._userConfiguration.freeze();
        }
      }

      return this._userConfiguration;
    }
  }, {
    key: "getConsolidateConfigurationModel",
    value: function getConsolidateConfigurationModel(overrides, workspace) {
      var configurationModel = this.getConsolidatedConfigurationModelForResource(overrides, workspace);
      return overrides.overrideIdentifier ? configurationModel.override(overrides.overrideIdentifier) : configurationModel;
    }
  }, {
    key: "getConsolidatedConfigurationModelForResource",
    value: function getConsolidatedConfigurationModelForResource(_ref, workspace) {
      var resource = _ref.resource;
      var consolidateConfiguration = this.getWorkspaceConsolidatedConfiguration();

      if (workspace && resource) {
        var root = workspace.getFolder(resource);

        if (root) {
          consolidateConfiguration = this.getFolderConsolidatedConfiguration(root.uri) || consolidateConfiguration;
        }

        var memoryConfigurationForResource = this._memoryConfigurationByResource.get(resource);

        if (memoryConfigurationForResource) {
          consolidateConfiguration = consolidateConfiguration.merge(memoryConfigurationForResource);
        }
      }

      return consolidateConfiguration;
    }
  }, {
    key: "getWorkspaceConsolidatedConfiguration",
    value: function getWorkspaceConsolidatedConfiguration() {
      if (!this._workspaceConsolidatedConfiguration) {
        this._workspaceConsolidatedConfiguration = this._defaultConfiguration.merge(this.userConfiguration, this._workspaceConfiguration, this._memoryConfiguration);

        if (this._freeze) {
          this._workspaceConfiguration = this._workspaceConfiguration.freeze();
        }
      }

      return this._workspaceConsolidatedConfiguration;
    }
  }, {
    key: "getFolderConsolidatedConfiguration",
    value: function getFolderConsolidatedConfiguration(folder) {
      var folderConsolidatedConfiguration = this._foldersConsolidatedConfigurations.get(folder);

      if (!folderConsolidatedConfiguration) {
        var workspaceConsolidateConfiguration = this.getWorkspaceConsolidatedConfiguration();

        var folderConfiguration = this._folderConfigurations.get(folder);

        if (folderConfiguration) {
          folderConsolidatedConfiguration = workspaceConsolidateConfiguration.merge(folderConfiguration);

          if (this._freeze) {
            folderConsolidatedConfiguration = folderConsolidatedConfiguration.freeze();
          }

          this._foldersConsolidatedConfigurations.set(folder, folderConsolidatedConfiguration);
        } else {
          folderConsolidatedConfiguration = workspaceConsolidateConfiguration;
        }
      }

      return folderConsolidatedConfiguration;
    }
  }, {
    key: "toData",
    value: function toData() {
      var _this2 = this;

      return {
        defaults: {
          contents: this._defaultConfiguration.contents,
          overrides: this._defaultConfiguration.overrides,
          keys: this._defaultConfiguration.keys
        },
        user: {
          contents: this.userConfiguration.contents,
          overrides: this.userConfiguration.overrides,
          keys: this.userConfiguration.keys
        },
        workspace: {
          contents: this._workspaceConfiguration.contents,
          overrides: this._workspaceConfiguration.overrides,
          keys: this._workspaceConfiguration.keys
        },
        folders: _toConsumableArray(this._folderConfigurations.keys()).reduce(function (result, folder) {
          var _this2$_folderConfigu = _this2._folderConfigurations.get(folder),
              contents = _this2$_folderConfigu.contents,
              overrides = _this2$_folderConfigu.overrides,
              keys = _this2$_folderConfigu.keys;

          result.push([folder, {
            contents: contents,
            overrides: overrides,
            keys: keys
          }]);
          return result;
        }, [])
      };
    }
  }], [{
    key: "parse",
    value: function parse(data) {
      var _this3 = this;

      var defaultConfiguration = this.parseConfigurationModel(data.defaults);
      var userConfiguration = this.parseConfigurationModel(data.user);
      var workspaceConfiguration = this.parseConfigurationModel(data.workspace);
      var folders = data.folders.reduce(function (result, value) {
        result.set(URI.revive(value[0]), _this3.parseConfigurationModel(value[1]));
        return result;
      }, new ResourceMap());
      return new Configuration(defaultConfiguration, userConfiguration, new ConfigurationModel(), workspaceConfiguration, folders, new ConfigurationModel(), new ResourceMap(), false);
    }
  }, {
    key: "parseConfigurationModel",
    value: function parseConfigurationModel(model) {
      return new ConfigurationModel(model.contents, model.keys, model.overrides).freeze();
    }
  }]);

  return Configuration;
}();
export var ConfigurationChangeEvent = /*#__PURE__*/function () {
  function ConfigurationChangeEvent(change, previous, currentConfiguraiton, currentWorkspace) {
    _classCallCheck(this, ConfigurationChangeEvent);

    this.change = change;
    this.previous = previous;
    this.currentConfiguraiton = currentConfiguraiton;
    this.currentWorkspace = currentWorkspace;
    this._previousConfiguration = undefined;
    var keysSet = new Set();
    change.keys.forEach(function (key) {
      return keysSet.add(key);
    });
    change.overrides.forEach(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          keys = _ref3[1];

      return keys.forEach(function (key) {
        return keysSet.add(key);
      });
    });
    this.affectedKeys = _toConsumableArray(keysSet.values());
    var configurationModel = new ConfigurationModel();
    this.affectedKeys.forEach(function (key) {
      return configurationModel.setValue(key, {});
    });
    this.affectedKeysTree = configurationModel.contents;
  }

  _createClass(ConfigurationChangeEvent, [{
    key: "previousConfiguration",
    get: function get() {
      if (!this._previousConfiguration && this.previous) {
        this._previousConfiguration = Configuration.parse(this.previous.data);
      }

      return this._previousConfiguration;
    }
  }, {
    key: "affectsConfiguration",
    value: function affectsConfiguration(section, overrides) {
      var _a;

      if (this.doesAffectedKeysTreeContains(this.affectedKeysTree, section)) {
        if (overrides) {
          var value1 = this.previousConfiguration ? this.previousConfiguration.getValue(section, overrides, (_a = this.previous) === null || _a === void 0 ? void 0 : _a.workspace) : undefined;
          var value2 = this.currentConfiguraiton.getValue(section, overrides, this.currentWorkspace);
          return !objects.equals(value1, value2);
        }

        return true;
      }

      return false;
    }
  }, {
    key: "doesAffectedKeysTreeContains",
    value: function doesAffectedKeysTreeContains(affectedKeysTree, section) {
      var requestedTree = toValuesTree(_defineProperty({}, section, true), function () {});
      var key;

      while (typeof requestedTree === 'object' && (key = Object.keys(requestedTree)[0])) {
        // Only one key should present, since we added only one property
        affectedKeysTree = affectedKeysTree[key];

        if (!affectedKeysTree) {
          return false; // Requested tree is not found
        }

        requestedTree = requestedTree[key];
      }

      return true;
    }
  }]);

  return ConfigurationChangeEvent;
}();